import { useEffect } from "react";
import Hotjar from "@hotjar/browser";
import { LocalStorage } from "../services/local-storage/LocalStorage";
import { useTrackedState } from "../store";

/**
 * Hook que permite inicializar la conexión con hotjar y pasa los datos del usuario
 */
export const useHotjar = () => {
    const state = useTrackedState();
    const instituto = state?.datosDeUsuario?.instituto;
    const tipoUsuario = state?.planActivo?.tipoUsuario;
    const nombre = state?.datosDeUsuario?.nombre;
    const nombreEstudiante = state?.perfilEstudiante?.nombre;
    const codigoEstudiante = state?.perfilEstudiante?.codigo;

    useEffect(() => {
        //indica el ID del sitio asignado por hotjar
        const siteId = 6526378;
        const hotjarVersion = 6;
        Hotjar.init(siteId, hotjarVersion);

        if (
            LocalStorage.obtenerEstadoSesion() ===
            LocalStorage.SESION_ESTADOS.activa
        ) {
            //evento que indica cuando la sesión esta ACTIVA
            Hotjar.event("active_session");

            if (tipoUsuario === "rector" || tipoUsuario === "profesor") {
                //Crea los filtros de búsqueda en hotjar para rector y profesor
                Hotjar.identify(instituto, {
                    instituto: instituto ? instituto : "null",
                    userType: tipoUsuario ? tipoUsuario : "null",
                    userName: nombre ? nombre : "null"
                })
            }else{
                Hotjar.identify(instituto, {
                    instituto: instituto ? instituto : "null",
                    userType: tipoUsuario ? tipoUsuario : "null",
                    userCode: codigoEstudiante ? codigoEstudiante : "null",
                    userNameStudent: nombreEstudiante ? nombreEstudiante : "null",
                })
            }

        } else {
            //evento que indica cuando  la sesión esta INACTIVA
            Hotjar.event("inactive_session");
        }
    }, [])
}